import { Layout, } from "@mcleod/components";

export abstract class AutogenLayoutDemoToastDialog extends Layout {
}
